import { omit, sortBy, toArray } from 'lodash';

import { HOME_FEATURED_CATEGORY_IDS } from '../../constants';

/**
 * Catégories mises en avant sur la page d'accueil (MEA type 97) : imposées
 * par la configuration (HOME_FEATURED_CATEGORY_IDS, ids par environnement),
 * dans l'ordre de la liste. Un id absent du référentiel est ignoré.
 */
export const getHomeFeaturedCategories = state =>
    HOME_FEATURED_CATEGORY_IDS.map(id => state.category.categories[id]).filter(Boolean);

/**
 * Référentiel des catégories trié sur `order` (colonne Ordre en base), pour les
 * menus du header. La réponse de /api/category est une map indexée par id : sans
 * tri explicite, toArray restitue l'ordre croissant des ids, qui ne correspond
 * pas forcément à l'ordre d'affichage voulu (cf. le select de l'annuaire).
 */
export const getOrderedCategories = state =>
    sortBy(toArray(omit(state.category.categories, 'loading')), 'order');



// WEBPACK FOOTER //
// ./src/services/category/selector.js